/* eslint-disable no-console */
import React, { Fragment, useEffect, useState } from 'react';
// import { contents } from '../../../Utils/options';
// import MenuCard from './MenuCard';
import menuImage from 'Assets/img/svg/menuImage.svg';
// import { useStyles } from './menu.style';
import Header from 'Components/Header/Header';
import { CommonButtonTypes } from 'Common/Types/Types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { RootState } from 'ReduxStore';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { GetProfile } from 'ReduxStore/profile/Action';
import { Routes } from 'Utils';

import { getToy } from 'ReduxStore/toys/Action';
import { useStyles } from 'Components/Reusable/Menu/menu.style';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import { PlainInput } from 'Components/Reusable/Inputs/PlainInput';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import { lookupKids } from 'ReduxStore/children/Action';
import AdminHeader from 'Components/Header/AdminHeader';
const AdminHomePage = ({ common }: CommonButtonTypes) => {
	const history = useHistory();
	const classes = useStyles({ common });
	const matches = useMediaQuery('(max-width:440px)');
	const dispatch = useDispatch();
	const [childId, setChildId] = useState<string>('');
	const error = useSelector((state: RootState) => state.children.error);

	console.log(error, 'An error here');
	useEffect(() => {
		if (localStorage.getItem('token') === undefined) {
			// eslint-disable-next-line no-console
			console.log('my token is found');
			return history.push(Routes.AdminLogin);
		}
	});
	useEffect(() => {
		// dispatch(getP());
		const getProfile = async () => GetProfile()(dispatch);
		getProfile();
	}, []);

	const onChange = (childId: string) => {
		setChildId(childId);
	};

	const onClickSubmit = () => {
		if (!childId) {
			alert('You need to input the child id');
		} else {
			console.log(childId, 'here now');
			// dispatch(lookupKids(childId));
			console.log('This is here were things happen for a reason!');
			return history.push(`boxes/${childId}`);
		}
	};

	return (
		<Fragment>
			<div className="">
				{/* <Header /> */}
				<AdminHeader />
				<div style={{ padding: '2rem' }} className={` d-flex flex-row justify-content-center`} />
				<div className={classes.greetingInformation}>
					{error && <h3>{error.message}</h3>}
					<div style={{ padding: '1rem', display: 'flex', flexDirection: 'column' }}>
						{/* <h3 className={classes.greetings}>Greetings </h3> */}
						<h3>Look up membership</h3>
					</div>
					{/* <section className={classes.homeDisplay}> */}
					{/* style={{ color: matches ? '#0d6efd' : 'white' }} */}
					<section style={{ display: 'flex', flexDirection: matches ? 'column' : 'row', rowGap: '1rem' }}>
						<PlainInput
							name="Full name"
							// label="Child Id"
							type="number"
							placeholder=""
							fvalue=""
							width={matches ? '241px' : '381.87px'}
							height="53.91px"
							defaultValue=""
							onChange={onChange}
							required={true}
						/>
						<div style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}></div>
						<CommonButton
							command="Submit"
							common={{
								width: matches ? '241px' : '381.87px',
								height: '48px',
								background: '#7FD6DD',
								radius: '10px',
								color: 'white',
								// marginRight: '1rem',
							}}
							onClick={onClickSubmit}
							disabled={childId ? false : true}
						/>
					</section>
				</div>
			</div>
		</Fragment>
	);
};

export default AdminHomePage;
